import { useTranslation } from 'react-i18next';
import { DarwinModal } from 'components/darwin-ui/Modal';
import { DarwinFlex } from 'components/darwin-ui';
import { WarningOutlined } from '@ant-design/icons';
import styles from './Ui.module.css';
import { ButtonProps, LegacyButtonType } from 'antd/es/button/button';

type GenericDeleteModalProps = {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
  confirmLoading?: boolean;
  bodyTitle?: string;
  bodyText?: string;
  okTitle?: string;
  okType?: LegacyButtonType;
  okButtonProps?: ButtonProps;
};

export const GenericDeleteModal = ({
  open,
  onCancel,
  onOk,
  confirmLoading = false,
  bodyTitle,
  bodyText,
  okTitle,
  okType,
  okButtonProps,
}: GenericDeleteModalProps) => {
  const { t } = useTranslation();

  return (
    <DarwinModal
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      cancelText={t('cancel')}
      okText={okTitle || t('delete')}
      confirmLoading={confirmLoading}
      okType={okType || undefined}
      okButtonProps={okButtonProps || undefined}
      centered
    >
      <DarwinFlex vertical align="center">
        <WarningOutlined className={styles.deleteModalIcon} />
        <div className={styles.deleteModalText}>{bodyTitle}</div>
        <div className={styles.deleteModalText}>{bodyText}</div>
      </DarwinFlex>
    </DarwinModal>
  );
};
